exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".branding-logo[data-v-62d7a029]{max-width:80%;height:60px;width:auto}.settings.left-nav-item[data-v-62d7a029]{position:absolute;width:100%;bottom:0}", ""]);

// exports
